<div class="snippet-manager">
  <div class="snippet-manager--content">
    <div *ngIf="isLoading">
      <xena-progress-bar indeterminate class="mb-4"></xena-progress-bar>
    </div>

    <div *ngIf="!isLoading" class="grid gap-2">
      <ng-container *ngFor="let template of templates" >
        <xena-textarea *ngIf="multiLines" [(ngModel)]="template.content">
          <xena-icon slot="tools" class="snippet-manager--icon" (click)="deleteTemplate(template)" name="far-trash-alt"></xena-icon>
        </xena-textarea>
        <xena-input *ngIf="!multiLines" [(ngModel)]="template.content">
          <xena-icon slot="suffix" class="snippet-manager--icon" (click)="deleteTemplate(template)" name="far-trash-alt"></xena-icon>
        </xena-input>
      </ng-container>
      <xena-alert type="info" class="col-span-full" inline i18n="@@snippetManager_addTemplateInfo"
        [open]="templates.length >= 15">
        You can't add more snippets, because you have reached the limit of 15 snippets.
      </xena-alert>
      <div>
        <xena-button type="primary" mode="text" (click)="addTemplate()" [disabled]="templates.length >= 15">
          <xena-icon name="fas-plus"></xena-icon>&nbsp;<span i18n="@@snippetManager_addNew">Add new</span>
        </xena-button>
      </div>
    </div>
  </div>
  <div class="snippet-manager--footer mt-4">
    <xena-button type="default" (click)="close()" class="mr-3" i18n="@@snippetManager_cancel">Cancel</xena-button>
    <xena-button type="primary" (click)="save()" [disabled]="isSaving" i18n="@@snippetManager_save">Save</xena-button>
    <div>
    </div>